import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, take } from 'rxjs';

import { UserFacade } from '../store/user/user.facade';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate {
  private userFacade = inject(UserFacade);
  private router = inject(Router);


  canActivate(): Observable<boolean> {
    return this.userFacade.getIsAuthenticated().pipe(
      take(1),
      map(isAuthenticated => {
        if (isAuthenticated) {
          this.router.navigate(['/']);
          return false;
        } else {
          return true;
        }
      })
    );
  }
} 